/**
 * @description
 */

import Api from '../../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IInput {
    /** 逗号分隔的 number 字符串 */
    resource_ids: string;
}

export interface IPPTToImgResultImg {
    url: string;
    size: number;
}

export enum ECovertStatus {
    NOT_START,
    END,
}

export interface IPPTToImgResult {
    status: ECovertStatus;
    resource_id: number;
    img_list: IPPTToImgResultImg[];
}

export type IOutput = IPPTToImgResult[];

export const pptToImgStatus = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PPT_TO_IMG_STATUS, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const pptToImgStatusSync = fetchDataSync<IInput>(pptToImgStatus);
